import React from 'react';
import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export const ErrorPage: React.FC = () => {
    const error = useRouteError();

    let errorMessage: string;
    let errorStatus: number | undefined;

    if (isRouteErrorResponse(error)) {
        errorStatus = error.status;
        errorMessage = error.statusText || error.data?.message || 'Something went wrong';
    } else if (error instanceof Error) {
        errorMessage = error.message;
    } else if (typeof error === 'string') {
        errorMessage = error;
    } else {
        console.error(error);
        errorMessage = 'Unknown error';
    }

    return (
        <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-4 isolate">
            {/* Background elements */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(120,119,198,0.1),rgba(255,255,255,0))]" />

            <div className="relative text-center max-w-md w-full">
                <div className="inline-flex items-center justify-center p-4 rounded-2xl bg-muted mb-8">
                    <span className="text-5xl font-semibold text-foreground">
                        {errorStatus || 'Error'}
                    </span>
                </div>

                <h1 className="text-2xl md:text-3xl font-semibold mb-4 text-foreground">
                    {errorStatus === 404 ? 'Page Not Found' : 'Something went wrong'}
                </h1>

                <p className="text-muted-foreground mb-10">
                    {errorStatus === 404
                        ? "The page you're looking for doesn't exist or has been moved."
                        : errorMessage}
                </p>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link
                        to="/"
                        className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity"
                    >
                        <Home className="mr-2 w-4 h-4" />
                        Home
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg border border-border text-foreground font-medium hover:bg-muted transition-colors"
                    >
                        <ArrowLeft className="mr-2 w-4 h-4" />
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};